// extracted by mini-css-extract-plugin
export const root = "Footer-module--root--2hEVX";
export const spacer = "Footer-module--spacer--2XDyT";